import { memo } from 'react';
import { ReactComponent as OpenEye } from 'assets/svg/eye-open.svg';
import { ReactComponent as OpenEyeHide } from 'assets/svg/eye-close.svg';
import Input from 'components/Input';
import RoundedButton from 'components/RoundedButtons';
import ErrorComponent from 'components/ErrorComponent';
import { label_text, name, new_pass_btn, placeholder } from '../constants/text';

const NewPassword = memo((props) => {
  const { formik, handleHidePasswords, passwordHide } = props;
  const { handleChange, errors, handleBlur, values, touched } = formik;

  return (
    <form onSubmit={formik.handleSubmit}>
      <Input
        type={passwordHide.password ? 'password' : 'text'}
        placeholder={placeholder.password}
        labelText={label_text.password}
        name={name.password}
        onChange={handleChange}
        isError={errors.password}
        onBlur={handleBlur}
        value={values.password}
        EndIcon={
          passwordHide.password ? (
            <OpenEyeHide onClick={() => handleHidePasswords('password')} />
          ) : (
            <OpenEye
              className='stroke-primary'
              onClick={() => handleHidePasswords('password')}
            />
          )
        }
      />

      {touched.password && errors.password ? (
        <ErrorComponent text={errors.password} />
      ) : null}

      <Input
        mainTagClassname='md:mt-6 mt-4'
        type={passwordHide.confirmPassword ? 'password' : 'text'}
        placeholder={placeholder.confirmPassword}
        labelText={label_text.confirmPassword}
        name={name.confirmPassword}
        onChange={handleChange}
        isError={errors.confirmPassword}
        onBlur={handleBlur}
        value={values.confirmPassword}
        EndIcon={
          passwordHide.confirmPassword ? (
            <OpenEyeHide
              onClick={() => handleHidePasswords('confirmPassword')}
            />
          ) : (
            <OpenEye
              className='stroke-primary'
              onClick={() => handleHidePasswords('confirmPassword')}
            />
          )
        }
      />

      {errors.confirmPassword&&errors.confirmPassword ? (
        <ErrorComponent text={errors.confirmPassword} />
      ) : null}

      <RoundedButton
        className='xl:mt-12 md:mt-8 mt-6 w-full font-semibold'
        isWidthFull={true}
        text={new_pass_btn}
        // onClick={(e) => {
        //   onSubmit(e);
        // }}
        type='submit'
      />
    </form>
  );
});

export default NewPassword;
